import React from 'react';
import { Alert, Button, Col, Form, InputGroup, Row } from 'react-bootstrap';

export default function AddExtraLessonsForm({
    loading,
    addLessonValidated,
    skipExtraLessonsPayment,
    CCNumber,
    CCFirstName,
    CCLastName,
    CCExpiration,
    CCCode,
    CCAddress,
    CCCity,
    CCState,
    CCZip,
    CCCountry,
    CCLessonsWanted,
    CCLessonsPrice,
    CCErrors,
    onChange,
    onToggleSkip,
    onSubmit
}) {
    return (
        <div>
            <h3>Add Extra Lessons</h3>
            <Form noValidate validated={addLessonValidated} onSubmit={onSubmit}>
                <Form.Check
                    inline
                    label="Skip Payment"
                    type="checkbox"
                    id="skipExtraLessonsPayment"
                    checked={skipExtraLessonsPayment}
                    onChange={onToggleSkip}
                />
                {!skipExtraLessonsPayment ? <div>
                    <InputGroup className="mb-3">
                        <Form.Control required
                            name="CCNumber"
                            type="text"
                            value={CCNumber}
                            placeholder="Card Number"
                            onChange={onChange}
                        />
                        <Form.Control.Feedback type="invalid">Please input a credit card number.</Form.Control.Feedback>
                    </InputGroup>

                    <Row>
                        <Col>
                            <Form.Label>First Name</Form.Label>
                            <Form.Control required
                                name="CCFirstName"
                                type="text"
                                value={CCFirstName}
                                placeholder="First Name"
                                onChange={onChange}
                            />
                            <Form.Control.Feedback type="invalid">Please input a first name.</Form.Control.Feedback>
                        </Col>
                        <Col>
                            <Form.Label>Last Name</Form.Label>
                            <Form.Control required
                                name="CCLastName"
                                type="text"
                                value={CCLastName}
                                placeholder="Last Name"
                                onChange={onChange}
                            />
                            <Form.Control.Feedback type="invalid">Please input a last name.</Form.Control.Feedback>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Form.Group controlId="CCExpiration">
                                <Form.Label>MM/YY</Form.Label>
                                <Form.Control required
                                    name="CCExpiration"
                                    type="text"
                                    value={CCExpiration}
                                    placeholder="MM/YY"
                                    onChange={onChange}
                                />
                                <Form.Control.Feedback type="invalid">Please input the credit card's expiration date.</Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group controlId="CCCode">
                                <Form.Label>CVC</Form.Label>
                                <Form.Control required
                                    name="CCCode"
                                    type="text"
                                    value={CCCode}
                                    placeholder="CVC"
                                    onChange={onChange}
                                />
                                <Form.Control.Feedback type="invalid">Please input the credit card's CVC.</Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Form.Group controlId="CCAddress">
                        <Form.Label>Billing Address</Form.Label>
                        <Form.Control required
                            name="CCAddress"
                            type="text"
                            value={CCAddress}
                            placeholder=""
                            onChange={onChange}
                        />
                        <Form.Control.Feedback type="invalid">Please input the credit card's billing address.</Form.Control.Feedback>
                    </Form.Group>

                    <Row>
                        <Col>
                            <Form.Label>City</Form.Label>
                            <Form.Control required
                                name="CCCity"
                                type="text"
                                value={CCCity}
                                placeholder="City"
                                onChange={onChange}
                            />
                            <Form.Control.Feedback type="invalid">Please input a city.</Form.Control.Feedback>
                        </Col>
                        <Col>
                            <Form.Label>State</Form.Label>
                            <Form.Control required
                                name="CCState"
                                type="text"
                                value={CCState}
                                placeholder="State"
                                onChange={onChange}
                            />
                            <Form.Control.Feedback type="invalid">Please input a state.</Form.Control.Feedback>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Form.Label>Zip</Form.Label>
                            <Form.Control required
                                name="CCZip"
                                type="text"
                                value={CCZip}
                                placeholder="Zip"
                                onChange={onChange}
                            />
                            <Form.Control.Feedback type="invalid">Please input a zip.</Form.Control.Feedback>
                        </Col>
                        <Col>
                            <Form.Label>Country</Form.Label>
                            <Form.Control required
                                name="CCCountry"
                                type="text"
                                value={CCCountry}
                                placeholder="Country"
                                onChange={onChange}
                            />
                            <Form.Control.Feedback type="invalid">Please input a country.</Form.Control.Feedback>
                        </Col>
                    </Row>
                </div> : <div></div>}
                <Row>
                    <Col>
                        <Form.Label>Lessons Wanted</Form.Label>
                        <Form.Control required
                            name="CCLessonsWanted"
                            type="number"
                            value={CCLessonsWanted}
                            placeholder="Lessons Wanted"
                            onChange={onChange}
                        />
                        <Form.Control.Feedback type="invalid">Please input the lessons wanted.</Form.Control.Feedback>
                    </Col>
                    <Col>
                        <Form.Label>Total Price</Form.Label>
                        <InputGroup>
                            <InputGroup.Text>$</InputGroup.Text>
                            <Form.Control required
                                name="CCLessonsPrice"
                                type="number"
                                value={CCLessonsPrice}
                                placeholder="Total Price"
                                onChange={onChange}
                            />
                            <Form.Control.Feedback type="invalid">Please input the total price of new lessons.</Form.Control.Feedback>
                        </InputGroup>
                    </Col>
                </Row>
                <br />
                <Button disabled={loading} type="submit">Add</Button>
                <br />
                <br />
            </Form>
            {CCErrors ? <Alert variant="warning"><strong>{CCErrors}</strong></Alert> : null}
        </div>
    );
}
